var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatches(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.95703 40.5117H0.980469V33.6758H1.95703V34.6523H2.44531V35.1406H2.93359V35.6289H3.91016V35.1406H4.39844V34.6523H4.88672V33.6758H5.86328V40.5117H4.88672V36.1172H4.39844V36.6055H3.91016V37.582H2.93359V36.6055H2.44531V36.1172H1.95703V40.5117ZM7.81641 37.582H10.7461V36.1172H10.2578V35.6289H9.76953V35.1406H8.79297V35.6289H8.30469V36.1172H7.81641V37.582ZM7.81641 40.5117H6.83984V35.6289H7.32812V35.1406H7.81641V34.6523H8.30469V34.1641H8.79297V33.6758H9.76953V34.1641H10.2578V34.6523H10.7461V35.1406H11.2344V35.6289H11.7227V40.5117H10.7461V38.5586H7.81641V40.5117ZM14.6523 34.6523H12.6992V33.6758H17.582V34.6523H15.6289V40.5117H14.6523V34.6523ZM20.0234 39.5352H21.9766V39.0469H22.4648V38.5586H23.4414V39.5352H22.9531V40.0234H22.4648V40.5117H19.5352V40.0234H19.0469V39.5352H18.5586V34.6523H19.0469V34.1641H19.5352V33.6758H22.4648V34.1641H22.9531V34.6523H23.4414V35.6289H22.4648V35.1406H21.9766V34.6523H20.0234V35.1406H19.5352V39.0469H20.0234V39.5352ZM25.3945 37.582V40.5117H24.418V33.6758H25.3945V36.6055H28.3242V33.6758H29.3008V40.5117H28.3242V37.582H25.3945ZM35.1602 33.6758V34.6523H31.2539V36.6055H34.1836V37.582H31.2539V39.5352H35.1602V40.5117H30.2773V33.6758H35.1602ZM40.5312 34.6523H41.0195V35.6289H40.043V35.1406H39.5547V34.6523H37.6016V35.1406H37.1133V36.1172H37.6016V36.6055H40.043V37.0938H40.5312V37.582H41.0195V39.5352H40.5312V40.0234H40.043V40.5117H37.1133V40.0234H36.625V39.5352H36.1367V38.5586H37.1133V39.0469H37.6016V39.5352H39.5547V39.0469H40.043V38.0703H39.5547V37.582H37.1133V37.0938H36.625V36.6055H36.1367V34.6523H36.625V34.1641H37.1133V33.6758H40.043V34.1641H40.5312V34.6523Z",
    fill: "#3DD22B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8564 2.28739H30.7089V1.13989H27.2814V2.28739H26.1414V5.71489H27.2814V6.85489H30.7089V5.71489H31.8564V2.28739Z",
    fill: "#3DD22B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7088 19.4248H29.5688V20.5723H30.7088V19.4248Z",
    fill: "#3DD22B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7089 13.7098H31.8564V10.2823H30.7089V9.14233H27.2814V10.2823H26.1414V13.7098H27.2814V14.8573H30.7089V13.7098Z",
    fill: "#3DD22B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5687 20.5725H28.4287V21.7125H29.5687V20.5725Z",
    fill: "#3DD22B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5687 18.2849H28.4287V19.4249H29.5687V18.2849Z",
    fill: "#3DD22B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4288 21.7124H27.2812V22.8599H28.4288V21.7124Z",
    fill: "#3DD22B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4288 17.1448H27.2812V18.2848H28.4288V17.1448Z",
    fill: "#3DD22B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7139 22.8598V21.7123H23.8539V18.2848H22.7139V17.1448H19.2864V18.2848H18.1389V21.7123H19.2864V22.8598H22.7139Z",
    fill: "#3DD22B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8539 10.2823H22.7139V9.14233H19.2864V10.2823H18.1389V13.7098H19.2864V14.8573H22.7139V13.7098H23.8539V10.2823Z",
    fill: "#3DD22B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8539 2.28739H22.7139V1.13989H19.2864V2.28739H18.1389V5.71489H19.2864V6.85489H22.7139V5.71489H23.8539V2.28739Z",
    fill: "#3DD22B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7113 21.7124H13.5713V22.8599H14.7113V21.7124Z",
    fill: "#3DD22B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7113 17.1448H13.5713V18.2848H14.7113V17.1448Z",
    fill: "#3DD22B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7113 13.7098H15.8588V10.2823H14.7113V9.14233H11.2838V10.2823H10.1438V13.7098H11.2838V14.8573H14.7113V13.7098Z",
    fill: "#3DD22B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8588 2.28739H14.7113V1.13989H11.2838V2.28739H10.1438V5.71489H11.2838V6.85489H14.7113V5.71489H15.8588V2.28739Z",
    fill: "#3DD22B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5713 20.5725H12.4238V21.7125H13.5713V20.5725Z",
    fill: "#3DD22B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5713 18.2849H12.4238V19.4249H13.5713V18.2849Z",
    fill: "#3DD22B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4237 19.4248H11.2837V20.5723H12.4237V19.4248Z",
    fill: "#3DD22B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatches);
export default __webpack_public_path__ + "static/media/Matches.3b395960ee9cd146462e52f581129c04.svg";
export { ForwardRef as ReactComponent };